module.exports = __webpack_public_path__ + "static/media/visitor.9a57c5d0.svg";